// Reaction Unicode to emoji mapping
export const UNICODE_EMOJI_MAP = {
    "U+1F60D": "😍",
    "U+1F92F": "🤯", 
    "U+1F4B0": "💰",
    "U+1F3AF": "🎯",
    "U+1F615": "🫤",
};

// Helper function to convert emoji to Unicode
export const emojiToUnicode = (input) => {
    // If it's already Unicode format, return as-is
    if (input && input.startsWith('U+')) {
        return input;
    }
    
    // If it's not an emoji, return as-is
    if (!input || input.length === 0) {
        return input;
    }
    
    // First try automatic conversion using built-in JavaScript methods
    try {
        // Get the code point of the first character
        const codePoint = input.codePointAt(0);
        return `U+${codePoint.toString(16).toUpperCase()}`;
    } catch (error) {
        console.warn(`Failed to convert emoji ${input} to Unicode:`, error);
    }
    
    // If automatic conversion fails, try manual mapping by finding the key
    const unicodeKey = Object.keys(UNICODE_EMOJI_MAP).find(key => UNICODE_EMOJI_MAP[key] === input);
    if (unicodeKey) {
        return unicodeKey;
    }
    
    // Fallback to original value
    return input;
};

// Helper function to convert Unicode to emoji
export const unicodeToEmoji = (input) => {
    // If it's already an emoji, return as-is
    if (input && input.length === 2 && input.charCodeAt(0) > 255) {
        return input;
    }
    
    // If it's not Unicode format, return as-is
    if (!input || !input.startsWith('U+')) {
        return input;
    }
    
    // Try automatic conversion first
    try {
        // Convert "U+1F60D" to "1F60D" and parse as hex
        const codePoint = parseInt(input.substring(2), 16);
        const emoji = String.fromCodePoint(codePoint);
        return emoji;
    } catch (error) {
        console.warn(`Failed to convert Unicode ${input} to emoji:`, error);
    }
    
    // If automatic conversion fails, try manual mapping
    if (UNICODE_EMOJI_MAP[input]) {
        return UNICODE_EMOJI_MAP[input];
    }
    
    // Fallback to original value
    return input;
};

// Get all available reaction emojis
export const REACTION_EMOJIS = Object.values(UNICODE_EMOJI_MAP); 